module.exports = __webpack_public_path__ + "img/technology_big.0a0e13d9.png";